import { Badge } from '../../../components/ui/badge';

import type { MediaContentType } from '../types/statistics';

const CONTENT_TYPE_BADGE_STYLES: Record<MediaContentType, string> = {
  IMAGE: 'bg-chart-1/15 text-foreground hover:bg-chart-1/15',
  REELS: 'bg-chart-2/20 text-foreground hover:bg-chart-2/20',
  VIDEO: 'bg-chart-4/15 text-foreground hover:bg-chart-4/15',
  CAROUSEL_ALBUM: 'bg-chart-3/20 text-foreground hover:bg-chart-3/20',
};

export function ContentTypeBadge({
  contentType,
  label,
}: {
  contentType: MediaContentType;
  label: string;
}): JSX.Element {
  return (
    <Badge variant="default" className={CONTENT_TYPE_BADGE_STYLES[contentType]}>
      {label}
    </Badge>
  );
}
